<template>
  <div class="content work_flow_wrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-tabs class="process-list" v-model="activeName" @tab-click="handleClick" > 
      
        <template v-for="(item,index) in approveStateOption" >
          <el-tab-pane  :label="item.label" :name="item.value"></el-tab-pane>
        </template>
      
    </el-tabs>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6" >
          <div class="search-area-div">药企名称</div>
          <el-select size="mini" filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择" @change="changeTenant">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName" :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称</div>
          <el-select
          size="mini"
            v-model="page.organisationGuidList"
            placeholder="请选择部门名称"
            class="ipt-sty"
            clearable
            filterable
            multiple
            collapse-tags
            @focus="getOrganisation()"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">核算月份</div>
          <el-date-picker
          size="mini"
            v-model="page.accountMonth"
            class="ipt-sty"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
      <el-row :gutter="24"  v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">提交日期</div>
          <el-date-picker
          size="mini"
              v-model="timeLists"
              class="ipt-sty"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">审批状态</div>
          <el-select size="mini" filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">是否已对冲</div>
          <el-select  size="mini" multiple filterable   v-model="page.isHedgeList" class="ipt-sty"  placeholder="请选择是否对冲" >
            <el-option
              v-for="item in trueOrFalseOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" >
          <div class="search-area-div">是否平台专属任务</div>
          <el-select size="mini" filterable clearable v-model="page.taskBelongCategory" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in categoryList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24"  v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">关联状态</div>
          <el-select  size="mini" filterable clearable v-model="page.isDownStreamUsed" class="ipt-sty"  placeholder="请选择" >
            <el-option
              v-for="item in isDownOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px'" >
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addData">质量审核申请</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="flowNo"
          label="流程编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.flowNo || '-' }}</template>
        </el-table-column>
              <!-- 流程名称 -->
          <!-- <el-table-column prop="flowName" min-width="100" label="流程名称" header-align="center" align="left"
                    fixed="left" show-overflow-tooltip>
                    <template slot-scope="scope">{{ (scope.row.approveVO && scope.row.approveVO.flowName) ?
                        scope.row.approveVO.flowName : '-' }}</template>
                </el-table-column> -->
        <el-table-column
          fixed="left"
          prop="staffName"
          label="发起人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="100"
        >
          <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="80">
          <template slot-scope="scope"
            ><span :class="getStateShow(scope.row.isHedge == 'Y'?'C':scope.row.approveState)">{{
              scope.row.approveState | approveState
            }}</span></template
          >
        </el-table-column>
        <el-table-column
          prop="isHedge"
          label="是否已对冲"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
          <template slot-scope="scope">{{ scope.row.isHedge == 'Y' ? '已对冲' : scope.row.isHedge == 'N'?'未对冲':'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="药企名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="200"
        >
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="organisationName"
          label="组织名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="accountMonth"
          label="核算月"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="80"
        >
          <template slot-scope="scope">{{ scope.row.accountMonth || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="isPrecise"
          label="是否精准考核"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.isPrecise == 'Y' ? '是':'否'}}</template>
        </el-table-column>
        <el-table-column
          prop="peopleNum"
          label="人数"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.peopleNum || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="totalMoney"
          label="考核总金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.totalMoney  | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="isDownCorrelate"
          label="关联状态"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.isDownCorrelate ||'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="inputTime"
          label="提交时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.inputTime | getTime }}</template>
        </el-table-column>

        <el-table-column
          prop="approveTime"
          label="操作时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.approveTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="editData(scope.row, 2)"
            >
              详情
            </a>
            <a
              class="txt-color"
              @click="
                passDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="
                rejectDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a class="txt-color" @click="toRevoke(scope.row)" v-if="getListBtnState('revoke', scope.row) == 'revoke'">
              撤销
            </a>
            <a
              class="txt-color"
              @click="editData(scope.row, 1)"
              v-if="getListBtnState('edit', scope.row) == 'edit'"
            >
              编辑
            </a>
            <a
              class="txt-color"
              v-if="getListBtnState('del', scope.row) == 'del'"
              @click="delData(scope.row.guid)"
            >
              删除
            </a>

            <!-- <a
              class="txt-color"
              v-if="getListBtnState('again', scope.row) == 'again'"
              @click="editData(scope.row, 3)"
            >
              重新提交
            </a> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import workFlowCommon from '@/uilt/workFlowCommon';
import Bus from '../../router/bus.js'
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      activeName:'',
      trueOrFalseOption: [
        { text: '已对冲', value: 'Y' },
        { text: '未对冲', value: 'N' },
      ],
      isDownOption: [
        { text: '已关联', value: 'Y' },
        { text: '未关联', value: 'N' },
      ],
      categoryList: [
        { text: '是', value: 2 },
        { text: '否', value: 1 },
      ],
      tableHeight: window.innerHeight - 300,
      contentMainHeight: window.innerHeight - 200,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      flowType: '00020',
      fullscreenLoading: false,
      currentStaffGuid: null,
      tenantList: [], //公司名称
      organisationList:[],
      timeLists:[],
      page: {
        isHedgeList: ['Y','N'],
        isDownStreamUsed:null,
        pageIndex: 1,
        tenantGuid: null,
        accountMonth: null,
        pageSize: 50,
        billCycle: null,
        staffGuid: null,
        organisationGuidList: [],
        approveState: null,
        taskBelongCategory:null,//平台专属任务
        listType: 0,
        startTime: null,
        endTime: null,
        totalPage: 0,
        totalRows: 0,
      },
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',
      approveSuggest: '',
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: '',
      approveStateOption: [
        { label: '全部', value: '' },
        { label: '草稿中', value: 'N' },
        { label: '审批中', value: 'A' },
        { label: '已通过', value: 'Y' },
        { label: '已驳回', value: 'R' },
        { label: '已撤销', value: 'C' },
      ],
      downStateOption: [
        { label: '全部', value: '' },
        { label: '已下发', value: 'Y' },
        { label: '未下发', value: 'N' },
        { label: '部分下发', value: 'P' },
      ],
    };
  },
  async activated(){
    await this.Mixins_getServiceProviderType();
    this.getList();
    this.getTenantList();
  },
  async created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    await this.Mixins_getServiceProviderType();
    this.getList();
    this.getTenantList();
  },
  watch: {
    showMore(val, oldVal) {
            if (val) {
                this.tableHeight = window.innerHeight - 340;
                this.contentMainHeight = window.innerHeight - 250;
                return;
            }
            if (!val) {
                this.tableHeight = window.innerHeight - 300;
                this.contentMainHeight = window.innerHeight - 250;
                return;
            }
        }
  },
  methods: {
    //获取操作按钮显隐
    getListBtnState(btnType, row) {
      let approveVO = row;
      return workFlowCommon.getListBtnState(
        btnType,
        approveVO.approveState,
        approveVO.staffGuid,
        approveVO.approveStaffGuids,
        this.currentStaffGuid,
        row.bizApproveState,
      );
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    //新增
    addData() {
      this.$router.push({
        path:'/qualityApprovalAdd',
        query:{ 
          productGuid : this.$route.query.productGuid
        }
      });
    },
    //获取药企
    getTenantList() {
      let self = this;
      let relType = null;
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        if (serviceProviderType == this.ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR) {
          relType = '123'; // 写死
        }
      } catch (error) { 
        console.log('error',error);
      }
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    tenantChange(val) {
      if (val) {
        this.organisationList = [];
        this.page.organisationGuidList = [];
        this.getOrganisationList(val);
      }
    },
    changeTenant(val){
      this.getOrganisationList(val)
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      if(!v){
        return
      }
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisation() {
      if (!this.page.tenantGuid) {
        this.$message.error('请选择药企名称后再选择部门!');
        return;
      }
    },
    //清空
    emptySearch() {
      this.page = {
        isHedgeList:['Y','N'],
        isDownStreamUsed:null,
        pageIndex: 1,
        tenantGuid: null,
        accountMonth: null,
        pageSize: 50,
        billCycle: null,
        staffGuid: null,
        organisationGuidList: [],
        approveState: null,
        listType: 0,
        startTime:null,
        endTime:null,
        totalPage: 0,
        totalRows: 0,
      };
      this.timeLists = [];
      this.getList(1);
    },
    //type 为1编辑 3重新提交 2为详情
    editData(row, type) {
      let approveVO = row;
      let query = {
        guid: row.guid,
        approveStaffGuid: approveVO.approveGuid,
        camundaInstanceId: approveVO.camundaInstanceId,
        camundaDeploymentId: approveVO.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: approveVO.staffGuid,
        submitStaffName: approveVO.staffName,
        productGuid : this.$route.query.productGuid
      };
      this.$router.push({
        path: type == 1 || type == 3 ? '/qualityApprovalAdd' : '/qualityApprovalDetail',
        query,
      });
    },
    getList(type) {
      let self = this;
      if (type == 1) {
        self.page.pageIndex = 1;
      }
      if (self.page.isHedgeList.length == 0) {
        self.page.isHedgeList = ['Y', 'N'];
      }
      self.tableLoading = true;
      self.page.currentTenantGuid = localStorage.guid;
      let query = JSON.parse(JSON.stringify(this.page));
      if (this.timeLists && this.timeLists.length > 0) {
        query.startTime = this.timeLists[0] + ' 00:00:00';
        query.endTime = this.timeLists[1] + ' 23:59:59';
      }
      if(self.page.accountMonth){
        query.accountMonth = query.accountMonth.replace('-','');
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      query.staffGuid = userInfo.staffGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/data/get-list`, query).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 删除
    delData(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/delete`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //撤销
    toRevoke(form) {
      let self = this;
      this.$confirm('确定撤销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: form.approveGuid,
            flowType: this.flowType,
            approveStaffGuid: form.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    handleClick() {
      this.page.approveState = this.activeName === '0' ? '' : this.activeName
      this.page.pageIndex = 1
      this.getList();
    }
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6 {
  display: flex;
  margin-bottom: 10px;
}
.ipt-sty {
  flex: 1;
}
/deep/ .el-input__prefix {
  top: -4px !important;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
}
.search-area {
  margin-bottom: 2px;
}
.process-list {
  background: #fff!important;
  overflow-y: auto;
}
.process-list /deep/ .el-tabs__header {
  margin: 0 0 8px;
}
.process-list /deep/ .el-tabs__nav-scroll {
  padding: 0 12px;
}
.process-list /deep/ .el-tabs__nav-wrap::after {
  background-color: #e9eef3;
}
.search-area {
  padding: 8px 16px
}
.search-area-div{
    flex-shrink: 0;
    margin-right: 4px;
    text-align:right;
  }
</style>
